import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";
import { HTS_ISOLATED_OLD_INCIDENT_NOTE } from "./sharedNotes";

export const substanceUse: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.SUBSTANCE_USE,
  label: "Substance use",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "which substance",
    "frequency",
    "most recent use",
    "the context or pattern of use",
  ],
  followUpTriggers: [
    "frequency or recency of use is vague",
    "it's unclear whether the pattern is ongoing",
  ],
  hardBarrierFacts: [
    "recent hard drug use",
  ],
  crossCuttingNotes: [
    "marijuana is legal, so it's treated as a frequency-and-timing question (agencies have abstinence windows before hire), not a character question",
    "hard drugs are treated much more strictly, especially recent use",
    HTS_ISOLATED_OLD_INCIDENT_NOTE,
    "alcohol use is questioned and sorted by quantity and pattern; heavy or coping-related drinking goes to a person, handled supportively rather than as a character flag",
  ],
};
